/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import getValue from 'src/components/GenericTable/utils/getValue';
import { invokeOrIdentity } from 'src/utils';
export function fromPgToLocalSorting(pgSorting) {
    return pgSorting.split(' ')[0] || 'asc';
}
export function getCellProps({ col, row }) {
    return { col, row, value: getValue(col, row) };
}
export function invokeWithCellPropsOrIdentity(invokable, cellProps) {
    return invokeOrIdentity(invokable, cellProps);
}
export function fromColumnToStrictColumn(column) {
    return Object.assign(Object.assign({}, column), { name: (column.name || column.field), field: (column.field || column.name) });
}
export function fromStrictColumnToColumn(column) {
    return Object.assign(Object.assign({}, column), { name: column.name, field: String(column.field) });
}
export function singleControlledAction(action) {
    return {
        create: action,
        fetch: action,
        update: action,
        delete: action,
        downloadList: action,
        uploadList: action
    };
}
export const anyUserCan = () => singleControlledAction(0);
export function sequentiallyNumberedControlledActions(action) {
    return {
        create: action,
        fetch: action + 1,
        update: action + 2,
        delete: action + 3,
        downloadList: action + 1,
        /** _20240706 */
        uploadList: [action, action + 2]
    };
}
